export const entryAccessValidation = (
  data: string,
  setError: (a: string) => void
) => {
  if (data === "") {
    setError("Field should not be empty.");
    return false;
  } else if (!/^\d+$/.test(data)) {
    setError("Entered value should be a number.");
    return false;
  } else {
    return true;
  }
};

export const phoneNumberValidation = (
  data: string,
  setError: (a: string) => void
) => {
  if (data === "") {
    setError("Field should not be empty.");
    return false;
  } else if (!/^[+]?[\d]+$/.test(data)) {
    setError("Entered value should be a phone number.");
    return false;
  } else {
    return true;
  }
};
